import {useEffect, useState} from 'react';
import {
  TourSection,
  isTourSectionSeen,
  markTourSectionSeen,
} from './tourStorage';

export function useGlobalTour(section: TourSection) {
  const [sectionSeen, setSectionSeen] = useState(() =>
    isTourSectionSeen(section),
  );
  const [runTour, setRunTour] = useState(false);
  const [tourStepIndex, setTourStepIndex] = useState(0);

  useEffect(() => {
    setSectionSeen(isTourSectionSeen(section));
    setTourStepIndex(0);
  }, [section]);

  useEffect(() => {
    setRunTour(!sectionSeen);
  }, [sectionSeen]);

  const markSeen = () => {
    markTourSectionSeen(section);
    setSectionSeen(true);
    setRunTour(false);
  };

  const handleJoyrideCallback = (data: any) => {
    const {status, index, type, action} = data;

    if (action === 'close') {
      setRunTour(false);
      return;
    }
    if (status === 'finished' || status === 'skipped') {
      markSeen();
      return;
    }
    if (type === 'step:after') {
      const next = action === 'prev' ? Math.max(0, index - 1) : index + 1;
      setTourStepIndex(next);
    }
  };

  return {
    runTour,
    tourStepIndex,
    handleJoyrideCallback,
    setRunTour,
  };
}
